import React from 'react';
import { cn } from '../lib/utils';

export const ProgressRing = ({ done, total, size = 84, stroke = 7, label, testId }) => {
  const pct = total ? Math.round((done / total) * 100) : 0;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const complete = total > 0 && done >= total;
  return (
    <div data-testid={testId} className="flex items-center gap-3">
      <div className="relative shrink-0" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="currentColor" strokeWidth={stroke} className="text-line" />
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100} className={cn('transition-[stroke-dashoffset,color] duration-700 ease-out', complete ? 'text-emerald-500' : 'text-ink-700')} />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center leading-none">
          <span data-testid={testId ? `${testId}-count` : undefined} className={cn('text-lg font-semibold tabular-nums', complete ? 'text-emerald-700' : 'text-ink-800')}>{done}<span className="text-ink-400 text-xs font-medium">/{total}</span></span>
        </div>
      </div>
      {label && <div className="text-sm"><div className={cn('font-semibold', complete ? 'text-emerald-700' : 'text-ink-800')}>{complete ? 'All items complete' : `${total - done} item${total - done === 1 ? '' : 's'} remaining`}</div><div className="text-xs text-ink-400 mt-0.5">{label}</div></div>}
    </div>
  );
};
